import { KycStatusAnalysis } from './components/kyc-status-analysis'
import { KycStatusOnboarding } from './components/kyc-status-onboarding'
import { KycStatusRejected } from './components/kyc-status-rejected'

export type KycStatusOnboardingProps = {
  actionButton?: () => void
}

export type KYC = 'analysis' | 'responsePending' | 'approved' | 'rejected'

export type KycOnboardingProps = {
  kycStatus: KYC
} & KycStatusOnboardingProps

function getKycOnboardingView(
  status: KycOnboardingProps['kycStatus'],
  actionButton?: () => void
): React.JSX.Element | null {
  const views = {
    responsePending: <KycStatusOnboarding actionButton={actionButton} />,
    analysis: <KycStatusAnalysis actionButton={actionButton} />,
    rejected: <KycStatusRejected actionButton={actionButton} />,
    approved: null
  }
  return views[status] ?? null
}

export function KycOnboarding({ kycStatus, actionButton }: KycOnboardingProps) {
  return getKycOnboardingView(kycStatus, actionButton)
}
